import script from "./AplicarRecesso.vue?vue&type=script&setup=true&lang=js"
export * from "./AplicarRecesso.vue?vue&type=script&setup=true&lang=js"

import "./AplicarRecesso.vue?vue&type=style&index=0&id=ebf3ed00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebf3ed00"]])

export default __exports__